import React, { useState } from "react";
import lock from "../../../../../Assets/lock.svg";
import "./Withdrawal-pages.css";
import {
  StyledBankTransferFormButton,
  ButtonGroup,
  colors,
} from "../../../../../Syles/styles";
import { Formik, Form } from "formik";
import Loader from "react-loader-spinner";
import * as Yup from "yup";
import { TextInput } from "../../../../Formik/FormLib";
import { useUser } from "../../../../../../hooks/use-user";
import { $api } from "../../../../../../helpers/$api";
import { Util } from "../../../../../../helpers/util";
import { OVEST_WITHDRAW } from "../../../../../../constants";
import backicon from "../../../../../Assets/backicon.svg";

const BankConfirmPassword = ({ setStage }) => {
  const { username } = useUser() || {};
  const [error, setError] = useState("");
  const payload = Util.get(OVEST_WITHDRAW);
  // const setChange = (e) => {
  //   setStage(0);
  // };

  const confirmPasswordAndWithdraw = async (password) => {
    try {
      await $api.user.login({ username, password });
      try {
        await $api.user.withdrawToOvest(payload);
        window.location.reload();
      } catch (error) {
        setError(error.message);
      }
    } catch (error) {
      setError("Invalid password");
    }
  };

  return (
    // <div>
    <div className="cardpaymentsuccess cardpassword">
      <div className="cardpassword-inner">
        <div>

        <button
          onClick={() => {
            setStage(0);
          }}
          style={{
            border: "none",
            background: "none",
            marginLeft: "34px",
          }}
        >
          <img src={backicon} alt="back icon" />
        </button>
        <button>
          <img className=" " src={lock} alt="card close icon" />
        </button>
        </div>
        <h5>Confirm Password</h5>
        <p style={{ color: "red" }}>{error}</p>
        <p>Enter your OVest password to approve your transaction</p>
        <Formik
          initialValues={{
            password: "",
          }}
          onSubmit={async (values, { setSubmitting }) => {
            await confirmPasswordAndWithdraw(values.password);
            setSubmitting(false);
          }}
          validationSchema={Yup.object({
            password: Yup.string()
              .min(8, "password is too short")
              .max(30, "password is too long")
              .required("Password is Required"),
          })}
        >
          {({ isSubmitting }) => (
            <Form>
              <TextInput
                style={{ width: "98%" }}
                name="password"
                type="password"
              />
              <ButtonGroup>
                {!isSubmitting && (
                  <StyledBankTransferFormButton type="submit">
                    Proceed
                  </StyledBankTransferFormButton>
                )}

                {isSubmitting && (
                  <Loader
                    type="ThreeDots"
                    color={colors.primary}
                    height={49}
                    width={100}
                  />
                )}
              </ButtonGroup>
            </Form>
          )}
        </Formik>
      </div>
    </div>
    // </div>
  );
};

export default BankConfirmPassword;
